import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import { IGetOrdersResponse, IGetOrdersVariables } from './types'
import getOrdersQuery from './query'

const useLazyGetOrders = (
  options?: LazyQueryHookOptions<IGetOrdersResponse, IGetOrdersVariables>,
) => {
  return useLazyQuery<IGetOrdersResponse, IGetOrdersVariables>(
    getOrdersQuery,
    options,
  )
}

export { useLazyGetOrders }
